{
  "goBack": "go back",
  "layout": {
    "offline": "You are currently offline."
  },
  "footer": {
    "copyright": "Copyright"
  },
  "validation": {
    "fieldRequired": "This field is required",
    "phoneInvalid": "Please enter a valid phone number."
  },
  "form": {
    "chooseOne": "Choose one",
    "select": "Select",
    "filterBy": "Filter by"
  },
  "colorMode": {
    "light": "Light",
    "dark": "Dark",
    "systemDefault": "System default",
    "lightThemeAlt": "light theme",
    "darkThemeAlt": "dark theme",
    "systemThemeAlt": "system theme"
  },
  "nav": {
    "messaging": "Secure Messaging",
    "attachments": "Attachment Library",
    "calendar": "Shared Calendar",
    "payments": "Accountable Payments",
    "info": "Info Library",
    "records": "Unalterable Records",
    "journal": "Personal Journal",
    "settings": "Account Settings",
    "help": "Help Center",
    "contact": "Contact Us",
    "signout": "Sign Out",
    "tryNewLook": "Try the New Look!",
    "tryNewLook_sm": "New Look!",
    "feedback": "Give us your feedback",
    "vault": "Vault File Storage",
    "calling": "Accountable Calling"
  },
  "titles": {
    "messaging": "Messaging with {name}",
    "messagingMobile": "Messaging",
    "attachments": "Attachment Library",
    "calendar": "Shared Calendar",
    "payments": "Accountable Payments",
    "info": "Info Library",
    "records": "Unalterable Records",
    "journal": "Personal Journal",
    "settings": "Account Settings",
    "help": "Help Center",
    "contact": "Contact Us",
    "vault": "Vault File Storage",
    "calling": "Accountable Calling"
  },
  "errorModal": {
    "header": "Something went wrong...",
    "fixError": "Please fix the error below and try again. If the problem continues, contact us at {contact}.",
    "errorText": "Error: {error}",
    "genericError": "Please check your connection and try again. If the problem continues, contact us at {contact}."
  },
  "characterLimitReached": "Character limit reached ({over} char).",
  "dropzone": {
    "title": "Drag and drop files or click to browse",
    "subtitle": "Maximum file uploads: {count} files, {size} each",
    "mobileTitle": "Add attachments | Add attachments ({count}) | Add attachments ({count})",
    "errors": {
      "header": "Could not add attachment",
      "illegalCharacters": {
        "title": "The attachment could not be added because the file name is invalid.",
        "subtitle": "File names should not contain any of the following characters: {characters}"
      },
      "illegalExtension": {
        "title": "The attachment could not be added because this file type is not accepted.",
        "subtitle": "Accepted file types: {types}"
      },
      "fileSizeTooBig": {
        "title": "File size is too big ({size}).",
        "subtitle": "Max file size: {size}."
      },
      "tooManyFiles": "You can only attach 5 files per message. You can not upload any more files."
    }
  },
  "attachFromVault": {
    "title": "Insert files from the Vault",
    "upgradeModal": {
      "header": "Upgrade to access Vault File Storage",
      "content": "Privately and securely store a variety of files. Similar to cloud storage, you can share links to files directly from your Vault.",
      "upgradeButton": "Upgrade"
    }
  },
  "serviceMark": "SM",
  "banners": {
    "upgradeBannerFreeText": "Upgrade your plan",
    "upgradeBannerStandardPlan": "Upgrade your plan",
    "highlightWords": "Standard, Premium Plan",
    "upgradeBannerMessageTier0": "for unlimited access to all attachments.",
    "upgradeBannerRecordsTier0": "to Enhanced or Ultimate for unlimited PDF access, plus discounted rates on Printed Records.",
    "upgradeBannerRecordsTier1": "to save an additional $10 on every Printed Record.",
    "restrictedCoParent": "Your co-parent does not have an active subscription.",
    "restrictedCoParentLearnMore": "Learn more"
  },
  "introPages": {
    "continue": "Continue",
    "upgradeButton": "Upgrade"
  },
  "search": {
    "placeholder": "Search"
  },
  "downloads": {
    "inProgressCancelModal": {
      "header": "Cancel downloads",
      "content": "Some items are still downloading. Are you sure you want to stop all of them?",
      "cancelButton": "Cancel",
      "confirmButton": "Confirm"
    },
    "list": {
      "headerSingle": "Downloading 1 item",
      "headerMultiple": "Downloading {count} items",
      "headerSingleCompleted": "Downloaded 1 item",
      "headerMultipleCompleted": "Downloaded {count} items",
      "item": {
        "issue": "There was an issue downloading your file. Please try again.",
        "completed": "Completed",
        "reDownload": "Re-download"
      }
    }
  },
  "uploads": {
    "list": {
      "headerSingle": "Uploading 1 item",
      "headerMultiple": "Uploading {count} items",
      "headerSingleCompleted": "Uploaded 1 item",
      "headerMultipleCompleted": "Uploaded {count} items",
      "item": {
        "converting": "Converting...",
        "issue": "There was an issue uploading your file. Please try again.",
        "pause": "Pause",
        "resume": "Resume upload",
        "completed": "Completed",
        "failed": "Failed"
      }
    }
  },
  "errors": {
    "existingSubscriptionTitle": "Existing active subscription",
    "existingSubscriptionMessage": "Your account already has an active subscription through TalkingParents. Please contact support for further assistance."
  },
  "states": {
    "label": "State",
    "defaultOption": "Select",
    "errorMessage": "State selection is required.",
    "al": "Alabama",
    "ak": "Alaska",
    "az": "Arizona",
    "ar": "Arkansas",
    "ca": "California",
    "co": "Colorado",
    "ct": "Connecticut",
    "de": "Delaware",
    "dc": "District of Columbia",
    "fl": "Florida",
    "ga": "Georgia",
    "hi": "Hawaii",
    "id": "Idaho",
    "il": "Illinois",
    "in": "Indiana",
    "ia": "Iowa",
    "ks": "Kansas",
    "ky": "Kentucky",
    "la": "Louisiana",
    "me": "Maine",
    "md": "Maryland",
    "ma": "Massachusetts",
    "mi": "Michigan",
    "mn": "Minnesota",
    "ms": "Mississippi",
    "mo": "Missouri",
    "mt": "Montana",
    "ne": "Nebraska",
    "nv": "Nevada",
    "nh": "New Hampshire",
    "nj": "New Jersey",
    "nm": "New Mexico",
    "ny": "New York",
    "nc": "North Carolina",
    "nd": "North Dakota",
    "oh": "Ohio",
    "ok": "Oklahoma",
    "or": "Oregon",
    "pa": "Pennsylvania",
    "ri": "Rhode Island",
    "sc": "South Carolina",
    "sd": "South Dakota",
    "tn": "Tennessee",
    "tx": "Texas",
    "ut": "Utah",
    "vt": "Vermont",
    "va": "Virginia",
    "wa": "Washington",
    "wv": "West Virginia",
    "wi": "Wisconsin",
    "wy": "Wyoming"
  },
  "searchFilterBar": {
    "buttonScreenReader": "Sort and filter",
    "search": {
      "searchButtonScreenReader": "Search",
      "clearButtonScreenReader": "Clear",
      "ariaLabel": "Search through site content"
    },
    "filter": {
      "mobileButtonScreenReader": "Filter by type",
      "desktopButton": "Type",
      "modalHeader": "Filters"
    },
    "dateRange": {
      "mobileButtonScreenReader": "Filter by date range",
      "desktopButton": "Date",
      "modalHeader": "Date range",
      "subtitle": "Date range"
    },
    "sort": {
      "mobileButtonScreenReader": "Sort by",
      "desktopButton": "Sort",
      "modalHeader": "Sorting",
      "subtitle": "Sort by"
    },
    "selectedFilters": {
      "filteringByTypeOrStartDateOnly": "Filtering by: {filter}",
      "filteringByDateRangeOnly": "Filtering by: {start} - {end}",
      "filteringByBothStartDate": "Filtering by: {filter}, {start}",
      "filteringByBothRange": "Filtering by: {filter}, {start} - {end}",
      "filterBy": "Filter by: {filter}",
      "sortingBy": "Sort by: {sort}",
      "none": "None",
      "clearAll": "Clear all",
      "clearFilter": "Clear filter",
      "clearSort": "Clear sort",
      "clearDates": "Clear dates",
      "noCountFound": "No matching search results for {search}."
    },
    "resetButton": "Reset",
    "applyButton": "Apply"
  },
  "aiUpsell": {
    "title": "AI Features",
    "description": "AI-powered assistance to enhance your experience.",
    "ctaText": "Access with Ultimate Plan",
    "responseLabel": "AI-suggested response:"
  },
  "landingPage": {
    "signIn": "Sign in",
    "getStarted": "Get started",
    "followUs": "Follow us",
    "termsOfService": "Terms of service",
    "privacyPolicy": "Privacy policy",
    "copyright": "Copyright © 2012 - {year} Monitored Communications, LLC"
  },
  "notFound": {
    "title": "Page not found",
    "text": "Oh no! The page you are looking for could not be found.",
    "goHomeCta": "Go home",
    "contactUsCta": "Contact us",
    "logoTitle": "Go to TalkingParents home page.",
    "logoAlt": "TalkingParents Logo"
  },
  "pdfDownload": {
    "title": "PDF Record",
    "downloadSuccess": "You successfully downloaded your PDF Record.",
    "inputPrompt": "Enter the 6-character access code you received in your email to download your record.",
    "requiredField": "indicates required",
    "accessCodeLabel": "Access code",
    "submitCodeCta": "Submit"
  },
  "newsletter": {
    "signup": {
      "title": "Stay up to date on co-parenting news",
      "description": "Get co-parenting tips and tricks, information from industry experts, updates on feature releases, and more sent straight to your inbox.",
      "requiredField": "indicates required",
      "emailLabel": "Email address",
      "signUpCta": "Sign me up"
    },
    "welcome": {
      "title": "Welcome to our community for co-parents!",
      "description": "You've taken the next step to make your co-parenting journey easier. You now have access to Parenting Resources covering an extensive variety of topics, Co-parenting & Coffee webinars hosted by industry experts and co-parents like you, and the latest news and updates related to TalkingParents.",
      "updatePreferencesDesc": "To update your preferences at any time, you can visit our subscription settings page.",
      "updatePreferencesCta": "Update my preferences",
      "parentingResourcesCta": "Take me to parenting resources"
    },
    "preferencesUpdated": {
      "title": "Your preferences are updated.",
      "description": "We've updated your preferences as requested. Enjoy a specially curated newsletter just for you!",
      "resourcesDescription": "Check out our collection of child-rearing information and parenting tips and tricks today."
    }
  },
  "contactUs": {
    "dropdown": {
      "label": "Why are you contacting us?",
      "placeholder": "Select a topic",
      "options": {
        "calling": "Accountable Calling<sup>SM</sup>",
        "free": "Free",
        "timestamp": "Timestamp",
        "createaccount": "Creating Account",
        "signin": "Sign In",
        "payment": "Payment",
        "attachments": "Attachments",
        "notifications": "Notifications",
        "records": "Records",
        "errormessage": "Received Error Message",
        "dv": "Domestic Violence",
        "profinquiry": "Professional Inquiry",
        "suggestion": "Suggestion",
        "event": "Co-Parenting & Coffee Event",
        "other": "Other"
      }
    },
    "issueDescription": {
      "label": "Please explain your issue in more detail",
      "hint": "Max 50,000 characters",
      "required": "Details are required."
    },
    "sendCta": "Send",
    "submittedState": {
      "title": "Form submitted",
      "thanks": "Thank you for contacting us.",
      "responseText": "Our support team will respond to you at {email} within two business days."
    }
  },
  "login": {
    "title": "Sign in {sr}",
    "titleSr": "to your account",
    "offlineError": "You are currently offline.",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "forgotPasswordCta": "Forgot email or password?",
    "contactUsCta": "Contact us",
    "signupCta": "Create an account",
    "loginStatus": "Logging in...",
    "signInButton": "Sign In"
  },
  "resetPassword": {
    "title": "Reset password {sr}",
    "updatedTitle": "Password updated {sr}",
    "srTitle": "for your account",
    "stepOne": {
      "title": "Choose a new password for account",
      "newPassword": {
        "label": "New password",
        "hint": "Must contain at least 10 characters, 1 letter, 1 number, and 1 special character."
      },
      "verifyPassword": {
        "label": "Verify password",
        "hint": "Re-enter your new password",
        "noMatchError": "Passwords do not match."
      },
      "updatePasswordCta": "Update Password"
    },
    "stepTwo": {
      "updateSuccessText": "Your password was successfully updated.",
      "loginText": "You can now sign in with your new password.",
      "returnToLoginCta": "Return to sign in"
    },
    "resetError": {
      "text": "Sorry, this reset link has expired or is invalid.",
      "requestNewLink": "Request new link"
    }
  },
  "forgotPassword": {
    "title": "Forgot email or password {sr}",
    "titleSr": "to your account",
    "description": "Enter the email address or mobile number associated with your account below and we will send you a link to reset your password.",
    "email": {
      "label": "Enter your email address",
      "submitCta": "Submit",
      "forgotEmailInstructions": {
        "label": "If you can't remember which email you used",
        "stepOne": "Enter any possible email addresses above, pressing the Submit button after each.",
        "stepTwo": "Check your inboxes for the password reset email from our system."
      }
    },
    "mobile": {
      "label": "Enter your mobile number",
      "sendCodeCta": "Send code"
    },
    "verifyCode": {
      "description": "We sent a 6-digit code to {phone}",
      "resentSuccess": "Verification code resent",
      "lengthError": "Verification code must be 6 digits in length"
    },
    "emailSentModal": {
      "title": "Email Instructions Sent",
      "description": "We've sent password reset instructions to your email address if it was found in our system. Please be sure to check your spam or junk folder.",
      "okayCta": "Okay"
    },
    "helpCenterCta": "Need help signing in?"
  },
  "password": {
    "requirement": "Please provide a password with at least 10 characters, one letter, one number, and one special character.",
    "hint": "Must contain at least 10 characters, 1 letter, 1 number, and 1 special character.",
    "toggle": {
      "show": "Show",
      "hide": "Hide"
    }
  },
  "accessibility": {
    "settings": "Settings"
  },
  "common": {
    "undo": "Undo",
    "dateTime": {
      "formatted": "{date} at {time}"
    },
    "tierCard": {
      "ultimate": {
        "bullets": [
          "Unlimited calling minutes",
          "50 GB Vault file storage",
          "Unlimited PDF Records",
          "Priority help desk support",
          "Express pay",
          "Sentiment Scanner + Writing Assist℠"
        ]
      },
      "enhanced": {
        "bullets": [
          "{minutes} calling minutes",
          "15 GB Vault File Storage",
          "Unlimited PDF Records"
        ]
      },
      "essentials": {
        "bullets": ["{minutes} calling minutes", "1 GB Vault File Storage"]
      }
    }
  },
  "notifications": {
    "professionalApprovalRequired": {
      "title": "Approval required",
      "description": "{name} accepted your invitation. Review access to complete the connection.",
      "reviewRequest": "Review request"
    }
  }
}
